import {Component, ElementRef, Injector, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';
import {isPlatformBrowser} from '@angular/common';
import {DeviceService} from '../../../util/service/device.service';

@Component({
  selector: 'app-header-client',
  standalone: false,
  templateUrl: './header-client.component.html',
  styleUrl: './header-client.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class HeaderClientComponent extends BaseComponent implements OnInit {
  @ViewChild('videoElement')
  video!: ElementRef<HTMLVideoElement>;
  videoIds = Config.branch.Details?.Videos ?? [];
  randomVideoUrl = '';
  isMobile?: boolean;
  protected readonly Config = Config;

  constructor(injector: Injector, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setRandomVideo();
  }

  setRandomVideo() {
    if (!this.isMobile) {
      this.randomVideoUrl = this.getRandomVideoUrl();
      if (isPlatformBrowser(Config.platformId)) {
        this.playVideoWithRetry();
      }
    }
  }

  playVideoWithRetry(retries = 10, delay = 200) {
    if (retries <= 0) {
      return;
    }
    setTimeout(() => {
      if (this.video?.nativeElement) {
        const videoElement = this.video.nativeElement;
        videoElement.muted = true;
        const playPromise = videoElement.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.playVideoWithRetry(retries - 1, delay * 2);
          });
        } else {
          this.playVideoWithRetry(retries - 1, delay * 2);
        }
      } else {
        this.playVideoWithRetry(retries - 1, delay * 2);
      }
    }, delay);
  }

  getRandomVideoUrl(): string {
    if (!this.videoIds?.length) return '';
    const randomIndex = Math.floor(Math.random() * this.videoIds.length);
    const randomId = this.videoIds[randomIndex];
    return this.formatVideo(randomId);
  }

  openLogin() {
    this.router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.SIGN_IN_COMPONENT]).then();
  }

  onProfileClicked() {
    this.router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.ACCOUNT_COMPONENT]).then();
  }

  onHomeClicked() {
    this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
  }

  onBranchHomeClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.LANDING_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onMenuClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.MENU_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onAboutUsClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ABOUT_US_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onOrdersClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ORDERS_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  openBasketClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.BASKET_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }
}
